// Prefill from URL params. Funnelish's thank-you page redirects here with the buyer's
// details in the query string (see the OnceHub snippet on that page). We map them onto the
// assessment's answer ids (email, firstName, lastName); mobile goes to the "Secure" step.
//
// Matching is CASE-INSENSITIVE and accepts common variants, so it works no matter how the
// upstream capitalizes/names them (e.g. name / firstName / first_name, lastName / lastname).
export function urlPrefill(search) {
  const out = { answers: {}, email: '', mobile: '' };
  try {
    const p = new URLSearchParams(search ?? window.location.search);
    const lower = {};
    for (const [k, v] of p) lower[k.toLowerCase()] = (v || '').trim();
    const pick = (...keys) => {
      for (const k of keys) if (lower[k]) return lower[k];
      return '';
    };
    const email = pick('email').toLowerCase();
    const first = pick('name', 'firstname', 'first_name', 'first');
    const last = pick('lastname', 'last_name', 'last', 'surname');
    if (email && /.+@.+\..+/.test(email)) { out.answers.email = email; out.email = email; }
    if (first) out.answers.firstName = first;
    if (last) out.answers.lastName = last;
    out.mobile = pick('mobile', 'phone');
  } catch { /* no window / bad params — return empty */ }
  return out;
}
